/* eslint-disable react/prop-types */
import AspectImage from 'components/aspectImage/AspectImage'
import { Fragment, h, JSX } from 'preact'

// interface IFeaturedProductProps {
//     product?: IProduct | null
//     addToWishlistTitle?: string
//     addToComparelistTitle?: string
//     addToCartTitle?: string
//     onAddToCartClick?: (product: IProduct) => any | undefined
//     onAddToWishlistClick?: (product: IProduct) => any | undefined
//     onAddToComparelistClick?: (product: IProduct) => any | undefined
//     showSku?: boolean | false
//     displayShortDescription?: boolean
//     groupedProductAutoNavigate?: boolean
//     numberOfShortDescriptionLines?: number
//     compact?: boolean
//     eager?: boolean
// }

export default function ProductBox({
    product,
    addToWishlistTitle,
    addToComparelistTitle,
    addToCartTitle,
    onAddToCartClick,
    onAddToWishlistClick,
    onAddToComparelistClick,
    showSku,
    displayShortDescription = true,
    groupedProductAutoNavigate = true,
    numberOfShortDescriptionLines = 3,
    compact = false,
    eager = false,
}) {
    if (!product) return null

    const shortDescriptionClassName = `description number-of-lines-${numberOfShortDescriptionLines}`

    const ratingPercent = product.reviewOverviewModel
        ? (product?.reviewOverviewModel?.ratingSum * 100) /
        product?.reviewOverviewModel?.totalReviews /
        5
        : undefined

    return (
        <a
            className="grid-item product-item --featured"
            data-product-id={product.id}
            href={product.url || product.seName}
        >
            <AspectImage
                className="grid__product-image"
                aspectRatio={{ x: 1, y: 1 }}
                src={product.defaultPictureModel.imageUrl}
                title={product.defaultPictureModel.title}
                alt={product.defaultPictureModel.alternateText}
                objectFit={'contain'}
                loading={eager ? 'eager' : 'lazy'}
            />

            {eager && (
                <link rel="preload" as="image" href={product.defaultPictureModel.imageUrl} />
            )}

            <div className={'essential'}>
                {(showSku || ratingPercent !== undefined) && (
                    <div className="details">
                        {showSku && product.sku && (
                            <div className="sku">
                                <span>{product.sku}</span>
                            </div>
                        )}

                        {ratingPercent !== undefined &&
                            product?.reviewOverviewModel
                                ?.allowCustomerReviews && (
                                <div className="product-rating-box">
                                    <div className="rating">
                                        <div
                                            style={`width: ${ratingPercent}%`}
                                        />
                                    </div>
                                </div>
                            )}
                    </div>
                )}

                <div className="product-details-wrapper">
                    <span className="product-title">{product.name}</span>

                    {displayShortDescription && product?.shortDescription && (
                        <div className={shortDescriptionClassName}>
                            {product.shortDescription}
                        </div>
                    )}
                </div>

                <div className="add-info">
                    <div
                        className={`prices ${product.productPrice.oldPrice ||
                            product.productPrice.priceWithDiscount
                            ? 'discounted'
                            : ''
                            }`}
                    >
                        {!product.productPrice.oldPrice &&
                            !product.productPrice.priceWithDiscount && (
                                <span className="price actual-price">
                                    {product.productPrice.priceFormated ||
                                        product.productPrice.price}
                                </span>
                            )}

                        {product.productPrice.priceWithDiscount && (
                            <Fragment>
                                <span className="price actual-price">
                                    {
                                        product.productPrice
                                            .priceWithDiscountFormated
                                    }
                                </span>
                                <span className="price old-price">
                                    {product.productPrice.priceFormated}
                                </span>
                            </Fragment>
                        )}

                        {product.productPrice.oldPrice &&
                            !product.productPrice.priceWithDiscount && (
                                <Fragment>
                                    <span className="price actual-price">
                                        {product.productPrice.priceFormated ||
                                            product.productPrice.price}
                                    </span>
                                    <span className="price old-price">
                                        {product.productPrice
                                            .oldPriceFormated ||
                                            product.productPrice.oldPrice}
                                    </span>
                                </Fragment>
                            )}

                        {product.productPrice.basePricePAngV && (
                            <div className="base-price-pangV">
                                {product.productPrice.basePricePAngV}
                            </div>
                        )}
                    </div>

                    <div className="buttons">
                        {onAddToWishlistClick &&
                            !product.productPrice.disableWishlistButton && (
                                <button
                                    type="button"
                                    className="add-to-wishlist-button"
                                    title={addToWishlistTitle}
                                    onClick={e => {
                                        e.preventDefault()
                                        e.stopPropagation()
                                        onAddToWishlistClick(product)
                                    }}
                                >
                                    <svg
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            fill-rule="evenodd"
                                            clip-rule="evenodd"
                                            d="M12.0122 5.57169L10.9252 4.48469C8.77734 2.33681 5.29493 2.33681 3.14705 4.48469C0.999162 6.63258 0.999162 10.115 3.14705 12.2629L11.9859 21.1017L11.9877 21.0999L12.014 21.1262L20.8528 12.2874C23.0007 10.1395 23.0007 6.65711 20.8528 4.50923C18.705 2.36134 15.2226 2.36134 13.0747 4.50923L12.0122 5.57169ZM11.9877 18.2715L16.9239 13.3352L18.3747 11.9342L18.3762 11.9356L19.4386 10.8732C20.8055 9.50635 20.8055 7.29028 19.4386 5.92344C18.0718 4.55661 15.8557 4.55661 14.4889 5.92344L12.0133 8.39904L12.006 8.3918L12.005 8.39287L9.51101 5.89891C8.14417 4.53207 5.92809 4.53207 4.56126 5.89891C3.19442 7.26574 3.19442 9.48182 4.56126 10.8487L7.10068 13.3881L7.10248 13.3863L11.9877 18.2715Z"
                                            fill="currentColor"
                                        />
                                    </svg>
                                    {/*<span>{addToWishlistTitle}</span>*/}
                                </button>
                            )}

                        {onAddToComparelistClick &&
                            !product.productPrice
                                .disableAddToCompareListButton && (
                                <button
                                    type="button"
                                    className="add-to-comparelist-button"
                                    title={addToComparelistTitle}
                                    onClick={e => {
                                        e.preventDefault()
                                        e.stopPropagation()
                                        onAddToComparelistClick(product)
                                    }}
                                >
                                    <svg
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M4.56079 10.6418L6.35394 3.94971L8.25402 5.84979C11.7312 3.6588 16.3814 4.07764 19.41 7.1063L17.9958 8.52052C15.7536 6.27827 12.3686 5.87519 9.71551 7.31128L11.2529 8.84869L4.56079 10.6418Z"
                                            fill="currentColor"
                                        />
                                        <path
                                            d="M19.4392 13.3581L17.646 20.0502L15.7459 18.1501C12.2688 20.3411 7.61857 19.9223 4.58991 16.8936L6.00413 15.4794C8.24638 17.7217 11.6313 18.1247 14.2844 16.6887L12.747 15.1512L19.4392 13.3581Z"
                                            fill="currentColor"
                                        />
                                    </svg>
                                    <span>{addToComparelistTitle}</span>
                                </button>
                            )}
                    </div>

                    {!product.productPrice.disableBuyButton && (
                        <button
                            type="button"
                            title={addToCartTitle}
                            className="add-to-cart-button"
                            onClick={
                                onAddToCartClick
                                    ? e => {
                                        e.stopPropagation()
                                        e.preventDefault()

                                        onAddToCartClick(product)
                                    }
                                    : () => { }
                            }
                        >
                            {product.productTypeId === 10 ||
                                product.productType === 10 ? (
                                <Fragment>
                                    <span>{addToCartTitle}</span>
                                    <svg
                                        width="24"
                                        height="24"
                                        viewBox="0 0 48 48"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            fill="var(--md-gray-950)"
                                            d="M4 23.9999C4 23.3096 4.55964 22.7499 5.25 22.7499H37.6959L24.8736 10.1413C24.3813 9.65725 24.3747 8.86582 24.8587 8.37358C25.3428 7.88134 26.1342 7.87468 26.6264 8.35872L41.6144 23.0969C41.6234 23.1056 41.6324 23.1145 41.6413 23.1235C41.853 23.3389 41.9709 23.6115 41.9952 23.8906C42.0023 23.9709 42.0015 24.0518 41.993 24.132C41.9644 24.4032 41.8473 24.667 41.6413 24.8765C41.6276 24.8904 41.6139 24.9039 41.6002 24.917L26.6264 39.6413C26.1342 40.1253 25.3428 40.1187 24.8587 39.6264C24.3747 39.1342 24.3813 38.3427 24.8736 37.8587L37.696 25.2499H5.25C4.55964 25.2499 4 24.6903 4 23.9999Z"
                                        />
                                    </svg>
                                </Fragment>
                            ) : (
                                <Fragment>
                                    <span>{addToCartTitle}</span>
                                    <svg
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            fillRule="evenodd"
                                            clipRule="evenodd"
                                            d="M5.79166 2H1V4H4.2184L6.9872 16.6776H7V17H20V16.7519L22.1932 7.09095L22.5308 6H6.6552L6.08485 3.38852L5.79166 2ZM19.9869 8H7.092L8.62081 15H18.3978L19.9869 8Z"
                                            fill="currentColor"
                                        />
                                        <path
                                            d="M10 22C11.1046 22 12 21.1046 12 20C12 18.8954 11.1046 18 10 18C8.89543 18 8 18.8954 8 20C8 21.1046 8.89543 22 10 22Z"
                                            fill="currentColor"
                                        />
                                        <path
                                            d="M19 20C19 21.1046 18.1046 22 17 22C15.8954 22 15 21.1046 15 20C15 18.8954 15.8954 18 17 18C18.1046 18 19 18.8954 19 20Z"
                                            fill="currentColor"
                                        />
                                    </svg>
                                </Fragment>
                            )}

                            {/*<span>{addToCartTitle}</span>*/}
                        </button>
                    )}
                </div>
            </div>
        </a>
    )
}
